export default __webpack_public_path__ + "assets/images/eaa39fd1f3629cd7927e265806f4c73f.svg";